import React, { useState, useEffect, useRef } from 'react';

import {
    Input,
    Label,
    InputWrapper,
    Note,
    ErrorText,
    ImageContainer,
    MobilePrefix,
    DropDown,
} from './styles';
import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';

const InputField = ({
    value,
    touched,
    errors,
    handleChange,
    handleBlur,
    placeholder,
    name,
    note,
    type,
    onChange,
    readOnly,
    handleClick,
    showError,
    setShowError,
    autoCapitalize,
    className,
    dropdown,
    // dropdownStyles,
    autoFocus,
    inputStyles,
    disabled,
    hideLabelText,
    customHandleBlur,
    inputContainerStyles,
    location,
    autoComplete,
    onFocus,
    mobilePrefix = false,
    calendar,
    // calendarIcon,
    // showCrossIcon,
    Icon,
}: any) => {
    const [focused, setFocused] = useState(false);
    const [isAutoFocused, setisAutoFocused] = useState(false);
    const inputEl = useRef(null);

    useEffect(() => {
        if (autoFocus && !isAutoFocused && inputEl !== null) {
            (inputEl as any).current.focus();
            setisAutoFocused(true);
        }
    }, [autoFocus]);

    // const handleCrossClick = (e) => {
    //     e.preventDefault();
    //     value = '';
    //     onChange(value, name);
    // };

    return (
        <InputWrapper styles={inputContainerStyles}>
            <div style={{ position: 'relative' }}>
                <Input
                    isPrefix={mobilePrefix}
                    ref={inputEl}
                    placeholder={placeholder}
                    id={name}
                    key={name}
                    type={type || 'text'}
                    name={name}
                    value={value || ''}
                    autoComplete={autoComplete}
                    onChange={(e) => {
                        if (handleChange) handleChange(e);
                        if (showError) setShowError(false);
                        const value = autoCapitalize
                            ? e.target.value.toUpperCase()
                            : e.target.value;
                        onChange && onChange(value, name); // eslint-disable-line
                    }}
                    onBlur={(e) => {
                        if (handleBlur) handleBlur(e);
                        if (customHandleBlur) customHandleBlur(e);
                        setFocused(false);
                    }}
                    onFocus={() => {
                        onFocus && onFocus();
                        setFocused(true);
                    }}
                    isError={errors[name] && touched[name]}
                    readOnly={readOnly || false}
                    autoCapitalize={autoCapitalize}
                    onClick={handleClick}
                    className={className}
                    // isDesktop={isDesktop}
                    pointerCursor={dropdown || location}
                    styles={inputStyles}
                    disabled={disabled}
                />
                {mobilePrefix && <MobilePrefix>+91</MobilePrefix>}
                {Icon}
                <Label focused={focused}>
                    {hideLabelText ? '' : placeholder}
                </Label>
                {/* <Label focused={focused} style={labelStyle}>{hideLabelText ? "" : placeholder}</Label> */}
            </div>
            {(showError || (errors[name] && touched[name])) && (
                <ErrorText
                    // isDesktop={isDesktop}
                    size="xxs"
                    margin={'4px 0px'}
                    // margin={isDesktop ? `0.05rem 1.1em 0.5rem` : `${$space.xs} 1.1em 0`}
                >
                    {errors[name]}
                </ErrorText>
            )}
            {note && (
                <Note
                    // isDesktop={isDesktop}
                    error={errors[name]}
                >
                    {note}
                </Note>
            )}

            {dropdown && <DropDown />}

            {calendar && (
                <ImageContainer>
                    <Image
                        width={'24px'}
                        height={'24px'}
                        alt={''}
                        src={getImageBasePath('/icons/calendar.svg')}
                    />
                </ImageContainer>
            )}
        </InputWrapper>
    );
};

export default InputField;
